import * as React from "react";
import { MapPin, Mail, ArrowRight, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const socialLinks = [{
  icon: Instagram,
  href: "https://www.instagram.com/une_vie_en_suede/",
  label: "Instagram"
}];
function FooterMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 bg-[var(--newsletter-foreground)]/10 animate-pulse rounded-md w-3/4" />)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id || i} data-index={i}>
          <Link to={item.href || "#"} className="text-[var(--newsletter-foreground)] hover:text-secondary text-sm font-default transition-colors inline-flex items-center gap-2 group">
            <ArrowRight className="size-3 opacity-0 -ml-5 transition-all group-hover:opacity-100 group-hover:ml-0" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265059" id="footer" className="dark bg-[var(--newsletter-background)] text-[var(--newsletter-foreground)] pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6 max-w-[1100px]">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <WvcLogo className="h-12 w-auto text-[var(--newsletter-foreground)]" />
            </Link>
            <p className="text-[var(--newsletter-foreground)] text-sm font-default leading-relaxed max-w-xs">Installée en Suède depuis 2025, je ne vends pas de rêve, je raconte un quotidien. À travers mes récits, je mets des mots sur nos choix de vie. Avec mes guides pratiques, nés de vos questions en coulisses, je vous aide à sauter le pas.</p>
            <div className="flex flex-col gap-2 mt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} className="flex items-center gap-2 text-sm text-[var(--newsletter-foreground)] hover:text-secondary transition-colors">
                    <Icon className="size-4" />
                    Une Vie en Suède sur Instagram
                  </Link>;
            })}
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-[var(--newsletter-foreground)]">
              Rubriques
            </h3>
            <MenuProvider menu_id="39">
              <FooterMenuContent />
            </MenuProvider>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-[var(--newsletter-foreground)]">
              Contact & Mentions
            </h3>
            <ul className="flex flex-col gap-4">
              <li>
                <Link to="/ContactPage" className="flex items-start gap-3 text-[var(--newsletter-foreground)] hover:text-secondary transition-colors group">
                  <MapPin className="size-5 shrink-0 mt-0.5 text-[var(--newsletter-foreground)] group-hover:text-secondary transition-colors" />
                  <span className="text-sm font-default leading-tight">
                    Suède / Scandinavie
                  </span>
                </Link>
              </li>
              <li>
                <a href="mailto:lydia@unevieensuede.com" className="flex items-center gap-3 text-[var(--newsletter-foreground)] hover:text-secondary transition-colors group">
                  <Mail className="size-5 shrink-0 text-[var(--newsletter-foreground)] group-hover:text-secondary transition-colors" />
                  <span className="text-sm font-default">lydia@unevieensuede.com</span>
                </a>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="my-8 bg-[var(--newsletter-foreground)]/10" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[var(--newsletter-foreground)] font-default">
          <p>
            &copy; {currentYear} UNE VIE EN SUÈDE par Lydia. Tous droits réservés.
          </p>
          <div className="flex items-center gap-4">
            <Link to="https://unevieensuede.com/politique-de-confidentialite" className="text-[var(--newsletter-foreground)] hover:text-secondary transition-colors">
              Politique de Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </section>;
}